var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcProfessionalContext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1067",
    "data-name": "Rectangle 1067",
    width: 29.723,
    height: 40.617,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_professional_context",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(338.972 220.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201-2",
    "data-name": "Group 201",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21804",
    "data-name": "Path 21804",
    d: "M29.723,26.488h-.536V10.824H27.125v-.751H22.167v2.259h4.958v-.66h1.213V26.488H24.959V19.962a7.339,7.339,0,0,0-7.331-7.331H16.8l-.741-.744-.02-.02a6,6,0,1,0-2.363,0l-.02.02-.741.744h-.825a7.339,7.339,0,0,0-7.331,7.331v6.526H0v6.329H2.876v7.8H26.847v-7.8h2.876ZM23.26,19.962v6.526H21.051V19.643h-1.7v6.845H15.577L16.063,26l1.378-1.378.6-.6-.114-.838-.965-7.033.483-.486,1.2-1.2-.05-.05a5.636,5.636,0,0,1,4.666,5.544m-7.019-5.494L15.158,15.55l1.083,7.867L14.863,24.8l-1.381-1.381,1.083-7.867-1.083-1.083.141-.137h.067v-.067l1.173-1.173ZM10.566,5.993a4.3,4.3,0,1,1,4.3,4.294,4.3,4.3,0,0,1-4.3-4.294m-4.1,13.968a5.639,5.639,0,0,1,4.666-5.544l-.05.05,1.2,1.2.483.486L11.8,23.186l-.114.838.6.6L13.66,26l.486.489H10.264V19.643h-1.7v6.845h-2.1ZM25.147,38.914H4.576v-6.1H25.147Zm2.876-7.8H1.7v-2.93H4.763v0h20.2v0h3.064Z",
    transform: "translate(0 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21805",
    "data-name": "Path 21805",
    d: "M12.332,9.846v6.523H10.12V9.528H8.42v6.842H4.646l.489-.486L6.513,14.5l.6-.6L7,13.071,6.03,6.038l.483-.486,1.2-1.2-.05-.05a5.639,5.639,0,0,1,4.666,5.544",
    transform: "translate(10.928 10.119)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21806",
    "data-name": "Path 21806",
    d: "M6.78,5.283,5.7,6.366,6.78,14.233,5.4,15.614,4.022,14.233,5.1,6.366,4.022,5.283l.141-.137H4.23V5.079L5.4,3.905Z",
    transform: "translate(9.459 9.186)",
    fill: "#faaf40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21807",
    "data-name": "Path 21807",
    d: "M3.152,4.8A4.3,4.3,0,1,1,7.446,9.095,4.3,4.3,0,0,1,3.152,4.8",
    transform: "translate(7.414 1.193)",
    fill: "#ffd0cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21808",
    "data-name": "Path 21808",
    d: "M1.928,9.846A5.639,5.639,0,0,1,6.594,4.3l-.05.05,1.2,1.2.483.486-.965,7.033-.114.835.6.6,1.378,1.381.486.486H5.726V9.528h-1.7v6.842h-2.1Z",
    transform: "translate(4.535 10.119)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1066",
    "data-name": "Rectangle 1066",
    width: 20.572,
    height: 6.101,
    transform: "translate(4.576 32.817)",
    fill: "#b0775a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21809",
    "data-name": "Path 21809",
    d: "M26.831,11.339H.507V8.409H3.571v0h20.2v0h3.064Z",
    transform: "translate(1.192 19.78)",
    fill: "#b0775a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21810",
    "data-name": "Path 21810",
    d: "M3.162,11.587H21.937V9.79H1.365v6.1h1.8Z",
    transform: "translate(3.211 23.028)",
    fill: "#f2d1c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21811",
    "data-name": "Path 21811",
    d: "M1.405,9.308H4.469v0h20.2v0h2.165v-.9H23.767v0H3.571v0H.507v2.93h.9Z",
    transform: "translate(1.193 19.78)",
    fill: "#f2d1c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21812",
    "data-name": "Path 21812",
    d: "M4.05,5.7a4.28,4.28,0,0,1,6.842-3.443A4.283,4.283,0,1,0,4.9,8.24,4.242,4.242,0,0,1,4.05,5.7",
    transform: "translate(7.414 1.193)",
    fill: "#fff3f2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfessionalContext);
export default __webpack_public_path__ + "static/media/ic_professional_context.ab2e74215dad658c53c777b8c62f61ec.svg";
export { ForwardRef as ReactComponent };